import { usePrivateUser } from "hooks/firestore/simple/usePrivateUser"
import { useUrlQuery } from "hooks/localstate/url/useUrlQuery"

export const useLastShop = () => {
  const [queryShop] = useUrlQuery("shop")
  const privateUser = usePrivateUser()
  const userShop = privateUser?.lastShop
  return queryShop || userShop
}
